import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTehetsegesHallgatok, createTehetsegesHallgatok, updateTehetsegesHallgatok, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import SideTile from "../SideTile";
import Modal from 'react-modal';
// import "./TehetsegesHallgatok.css";
import "./SzakjelentesCreate.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { TEHETSEGESHALLGATOK_TRANSLATIONS } from './TehetsegesHallgatokTranslations';
import { HOK_RESZVETEL_OPTIONS, SZAKKOLLEGIUM_RESZVETEL_OPTIONS, HALLGATOI_CSAPAT_RESZVETEL_OPTIONS, SPORT_RESZVETEL_OPTIONS, KIEMELKEDO_SPORTEREDMENY_OPTIONS, OSZTONDIJASOK_SZAMA_OPTIONS, OSZTONDIJASOK_ARANYA_OPTIONS } from './TehetsegesHallgatokOptions';


const TehetsegesHallgatokContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [tehetsegesHallgatok, setTehetsegesHallgatok] = useState({
        filling_status: 1
    });

    const [hokReszvetel, setHokReszvetel] = useState("");
    const [szakkollegiumReszvetel, setSzakkollegiumReszvetel] = useState("");
    const [hallgatoiCsapatReszvetel, setHallgatoiCsapatReszvetel] = useState("");
    const [sportReszvetel, setSportReszvetel] = useState("");
    const [kiemelkedoSporteredmeny, setKiemelkedoSporteredmeny] = useState("");
    const [osztondijasokSzama, setOsztondijasokSzama] = useState("");
    const [osztondijasokAranya, setOsztondijasokAranya] = useState("");

    const [images, setImages] = useState({
        tdk_otdk_eredmenyek_image: [],
        hallgatoi_onkormanyzat_image: [],
        szakkollegiumi_tevekenyseg_image: [],
        hallgatoi_csapatok_image: [],
        sporttevekenyseg_image: [],
        kiemelkedo_munka_image: []
    });

    const [isNew, setIsNew] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [finalized, setFinalized] = useState(false); // To track if the section is finalized
    const [szakStatus, setSzakStatus] = useState(1);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Get translations and options for current language - only after loading is complete
    const t = loading ? {} : (TEHETSEGESHALLGATOK_TRANSLATIONS[language] || TEHETSEGESHALLGATOK_TRANSLATIONS.hu);
    const hokReszvetelOptions = loading ? [] : (HOK_RESZVETEL_OPTIONS[language] || HOK_RESZVETEL_OPTIONS.hu);
    const szakkollegiumReszvetelOptions = loading ? [] : (SZAKKOLLEGIUM_RESZVETEL_OPTIONS[language] || SZAKKOLLEGIUM_RESZVETEL_OPTIONS.hu);
    const hallgatoiCsapatReszvetelOptions = loading ? [] : (HALLGATOI_CSAPAT_RESZVETEL_OPTIONS[language] || HALLGATOI_CSAPAT_RESZVETEL_OPTIONS.hu);
    const sportReszvetelOptions = loading ? [] : (SPORT_RESZVETEL_OPTIONS[language] || SPORT_RESZVETEL_OPTIONS.hu);
    const kiemelkedoSporteredmenyOptions = loading ? [] : (KIEMELKEDO_SPORTEREDMENY_OPTIONS[language] || KIEMELKEDO_SPORTEREDMENY_OPTIONS.hu);
    const osztondijasokSzamaOptions = loading ? [] : (OSZTONDIJASOK_SZAMA_OPTIONS[language] || OSZTONDIJASOK_SZAMA_OPTIONS.hu);
    const osztondijasokAranyaOptions = loading ? [] : (OSZTONDIJASOK_ARANYA_OPTIONS[language] || OSZTONDIJASOK_ARANYA_OPTIONS.hu);

    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getTehetsegesHallgatok(szakId);

                // Ellenőrzés: ha van a tömbben elem
                if (response.data.data.tehetsegesHallgatok.length > 0) {
                    const data = response.data.data.tehetsegesHallgatok[0];
                    setTehetsegesHallgatok(data);
                    setFinalized(data.filling_status === 3);

                    if (data.hok_reszvetel) setHokReszvetel(data.hok_reszvetel.selected || "");
                    if (data.szakkollegium_reszvetel) setSzakkollegiumReszvetel(data.szakkollegium_reszvetel.selected || "");
                    if (data.hallgatoi_csapat_reszvetel) setHallgatoiCsapatReszvetel(data.hallgatoi_csapat_reszvetel.selected || "");
                    if (data.sport_reszvetel) setSportReszvetel(data.sport_reszvetel.selected || "");
                    if (data.kiemelkedo_sporteredmeny) setKiemelkedoSporteredmeny(data.kiemelkedo_sporteredmeny.selected || "");
                    if (data.osztondijasok_szama) setOsztondijasokSzama(data.osztondijasok_szama.selected || "");
                    if (data.osztondijasok_aranya) setOsztondijasokAranya(data.osztondijasok_aranya.selected || "");

                    setIsNew(false);
                } else {
                // Ha a válasz sikeres, de üres a lista (nem 404, de nincs adat)
                console.log("No data found, creating a new record...");
                const newRecord = { filling_status: 1 };
                await createTehetsegesHallgatok(szakId, newRecord);
                setTehetsegesHallgatok(newRecord);
                window.location.reload();
            }
        } catch (error) {
            // Itt kezeljük, ha a szerver 404-et dob (nincs még ilyen rekord)
            if (error.response && error.response.status === 404) {
                console.log("404 Error: Creating a new entry...");
                const newRecord = { filling_status: 1 };
                await createTehetsegesHallgatok(szakId, newRecord);
                setTehetsegesHallgatok(newRecord);
                window.location.reload();
            } else {
                console.error("Error fetching data:", error);
            }
        }
    };

    fetchData();
}, [szakId]);

    const fetchImages = async () => {
        try {
            const tdkImages = await fetchImagesBySection("tdk_otdk_eredmenyek_image");
            const hokkImages = await fetchImagesBySection("hallgatoi_onkormanyzat_image");
            const szakkImages = await fetchImagesBySection("szakkollegiumi_tevekenyseg_image");
            const csapatImages = await fetchImagesBySection("hallgatoi_csapatok_image");
            const sportImages = await fetchImagesBySection("sporttevekenyseg_image");
            const kiemelkedoImages = await fetchImagesBySection("kiemelkedo_munka_image");

            setImages({
                tdk_otdk_eredmenyek_image: tdkImages,
                hallgatoi_onkormanyzat_image: hokkImages,
                szakkollegiumi_tevekenyseg_image: szakkImages,
                hallgatoi_csapatok_image: csapatImages,
                sporttevekenyseg_image: sportImages,
                kiemelkedo_munka_image: kiemelkedoImages
            });
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const fetchImagesBySection = async (section) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/images/${section}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch images for section: ${section}`);
            }
            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error(`Error fetching images for section ${section}:`, error);
            return [];
        }
    };

    const handleChange = (field, value) => {
        setTehetsegesHallgatok(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    const handleDrop = async (acceptedFiles, section) => {
        if (finalized) return; // Disable image upload if finalized
    
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', section);
    
        try {
            if (isNew) {
                const response = await createTehetsegesHallgatok(szakId, tehetsegesHallgatok);
                setIsNew(false);
                setTehetsegesHallgatok(response.data);
            }
    
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });
    
            if (!response.ok) {
                throw new Error('Failed to upload image');
            }
    
            const uploadResponse = await response.json();
    
            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => ({
                    ...prevImages,
                    [section]: [...prevImages[section], { ...uploadResponse, image_path: imagePath }]
                }));
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };
    
    const handleDeleteImage = async (imageId, section) => {
        if (finalized) return; // Disable image deletion if finalized

        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });
            setImages((prevImages) => ({
                ...prevImages,
                [section]: prevImages[section].filter(img => img.id !== imageId)
            }));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { ...tehetsegesHallgatok, filling_status: 2,
            hok_reszvetel: buildRadioData(hokReszvetel, hokReszvetelOptions),
            szakkollegium_reszvetel: buildRadioData(szakkollegiumReszvetel, szakkollegiumReszvetelOptions),
            hallgatoi_csapat_reszvetel: buildRadioData(hallgatoiCsapatReszvetel, hallgatoiCsapatReszvetelOptions),
            sport_reszvetel: buildRadioData(sportReszvetel, sportReszvetelOptions),
            kiemelkedo_sporteredmeny: buildRadioData(kiemelkedoSporteredmeny, kiemelkedoSporteredmenyOptions),
            osztondijasok_szama: buildRadioData(osztondijasokSzama, osztondijasokSzamaOptions),
            osztondijasok_aranya: buildRadioData(osztondijasokAranya, osztondijasokAranyaOptions)

            }; // Always save with status 2
            try {
                if (isNew) {
                    await createTehetsegesHallgatok(szakId, updatedData);
                } else {
                    await updateTehetsegesHallgatok(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [tehetsegesHallgatok, isNew, szakId, registerSaveHandler, unregisterSaveHandler, hokReszvetel, szakkollegiumReszvetel, hallgatoiCsapatReszvetel, sportReszvetel, kiemelkedoSporteredmeny, osztondijasokSzama, osztondijasokAranya]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { ...tehetsegesHallgatok, filling_status: status,
            hok_reszvetel: buildRadioData(hokReszvetel, hokReszvetelOptions),
            szakkollegium_reszvetel: buildRadioData(szakkollegiumReszvetel, szakkollegiumReszvetelOptions),
            hallgatoi_csapat_reszvetel: buildRadioData(hallgatoiCsapatReszvetel, hallgatoiCsapatReszvetelOptions),
            sport_reszvetel: buildRadioData(sportReszvetel, sportReszvetelOptions),
            kiemelkedo_sporteredmeny: buildRadioData(kiemelkedoSporteredmeny, kiemelkedoSporteredmenyOptions),
            osztondijasok_szama: buildRadioData(osztondijasokSzama, osztondijasokSzamaOptions),
            osztondijasok_aranya: buildRadioData(osztondijasokAranya, osztondijasokAranyaOptions)
         };

        try {
            if (isNew) {
                await createTehetsegesHallgatok(szakId, updatedData);
            } else {
                await updateTehetsegesHallgatok(szakId, updatedData);
            }
            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/idegen-nyelvi-korulmenyek`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-mintaterve`);
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        const hasAllRadioSelections = hokReszvetel && szakkollegiumReszvetel &&hallgatoiCsapatReszvetel && sportReszvetel && kiemelkedoSporteredmeny && osztondijasokSzama && osztondijasokAranya;

        return (
            hasAllRadioSelections
        );
    };

    const handleRevertFinalize = async (e) => {
        handleSubmit(e, 2); // Status 2-re állítása
    };

    const handleFinalize = async (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };


    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />            
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    {/* 3.1 TDK – Hallgatói önkormányzatban végzett tevékenység */}
                    <div className="card">
                        <h2>{t.section1.title}</h2>
                        <p>
                            {t.section1.source} <a href="https://seafile.sze.hu/f/7334fe40c9b34f10a010/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/7334fe40c9b34f10a010/</a> <br></br> </p>
                        <h4>
                            {t.section1.subtitle}
                        </h4>
                        <div className="form-group">
                            {hokReszvetelOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`hok_reszvetel_${option.value}`}
                                        name="hok_reszvetel"
                                        value={option.value}
                                        checked={hokReszvetel === option.value}
                                        onChange={(e) => setHokReszvetel(e.target.value)}
                                        disabled={finalized}
                                        />
                                        <label htmlFor={`hok_reszvetel_${option.value}`}>{option.label}</label>
                                    </div>
                                ))}
                        </div>
                    </div>

                    {/* 3.2 Szakkollégiumi tevékenység */}
                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        <p>
                            {t.section2.source} <a href="https://seafile.sze.hu/f/35ecae0458f04e7191d8/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/35ecae0458f04e7191d8/</a> </p>
                        <h4> {t.section2.subtitle} </h4>
                        <div className="form-group">
                        {szakkollegiumReszvetelOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szakkollegium_reszvetel_${option.value}`}
                                        name="szakkollegium_reszvetel"
                                        value={option.value}
                                        checked={szakkollegiumReszvetel === option.value}
                                        onChange={(e) => setSzakkollegiumReszvetel(e.target.value)}
                                        disabled={finalized}
                                        />
                                        <label htmlFor={`szakkollegium_reszvetel_${option.value}`}>{option.label}</label>
                                    </div>
                                ))}
                        </div>
                    </div>


                    {/* 3.3 Hallgatói csapatokban való tevékenység */}
                    <div className="card">
                        <h2>{t.section3.title}</h2>
                        <p>{t.section3.source} <a href="https://seafile.sze.hu/f/82c7ee47275b4129a2dc/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/82c7ee47275b4129a2dc/</a> </p>
                        <h4> {t.section3.subtitle} </h4>
                        <div className="form-group">
                            {hallgatoiCsapatReszvetelOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`hallgatoi_csapat_reszvetel_${option.value}`}
                                    name="hallgatoi_csapat_reszvetel"
                                    value={option.value}
                                    checked={hallgatoiCsapatReszvetel === option.value}
                                    onChange={(e) => setHallgatoiCsapatReszvetel(e.target.value)}
                                    disabled={finalized}
                                />
                                <label htmlFor={`hallgatoi_csapat_reszvetel_${option.value}`}>{option.label}</label>
                            </div>
                        ))}
                    </div>
                    </div>
                    
                        {/* 3.4 Sporttevékenység */}
                        <div className="card">
                        <h2>{t.section4.title}</h2>
                        <p>
                            {t.section4.source} <a href="https://seafile.sze.hu/f/f9d483d3d83f47a4ab9a/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/f9d483d3d83f47a4ab9a/</a>
                        </p>
                        <h4>{t.section4.subtitle1}</h4>
                        <div className="form-group">
                            {sportReszvetelOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`sport_reszvetel_${option.value}`}
                                        name="sport_reszvetel"
                                        value={option.value}
                                        checked={sportReszvetel === option.value}
                                        onChange={(e) => setSportReszvetel(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`sport_reszvetel_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section4.subtitle2}</h4>
                        <div className="form-group">
                            {kiemelkedoSporteredmenyOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kiemelkedo_sporteredmeny_${option.value}`}
                                        name="kiemelkedo_sporteredmeny"
                                        value={option.value}
                                        checked={kiemelkedoSporteredmeny === option.value}
                                        onChange={(e) => setKiemelkedoSporteredmeny(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`kiemelkedo_sporteredmeny_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* 3.5 Kiemelkedő tanulmányi/szakmai munkáért ösztöndíjban részesülők száma */}
                    <div className="card">
                        <h2>{t.section5.title}</h2>
                        <p>
                            {t.section5.source} <a href="https://seafile.sze.hu/f/c658fdf7d4ac47b29e18/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/c658fdf7d4ac47b29e18/</a>
                        </p>
                        <h4>{t.section5.subtitle1}</h4>
                        <div className="form-group">
                            {osztondijasokSzamaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`osztondijasok_szama_${option.value}`}
                                        name="osztondijasok_szama"
                                        value={option.value}
                                        checked={osztondijasokSzama === option.value}
                                        onChange={(e) => setOsztondijasokSzama(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`osztondijasok_szama_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section5.subtitle2}</h4>
                        <div className="form-group">
                            {osztondijasokAranyaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`osztondijasok_aranya_${option.value}`}
                                        name="osztondijasok_aranya"
                                        value={option.value}
                                        checked={osztondijasokAranya === option.value}
                                        onChange={(e) => setOsztondijasokAranya(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`osztondijasok_aranya_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={finalized ? handleRevertFinalize : handleFinalize} disabled={szakStatus >= 2}>
                            {finalized ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>
                </form>
            </div>

            <SideTile 
                ref={sideTileRef}
                id={szakId} 
                texts={t.sidebar}
                isVisible={isSideTileVisible}
            />

            <Modal
                isOpen={!!selectedImage} 
                onRequestClose={() => setSelectedImage(null)} 
                contentLabel={t.modal?.imageAlt || "Kép nagyítása"}
                className="image-modal"
                overlayClassName="image-modal-overlay"
            >
                {selectedImage && (
                    <div>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${selectedImage}`} alt={t.modal?.imageAlt || "Nagyított kép"} className="modal-image"/>
                        <button onClick={() => setSelectedImage(null)} className="modal-close-button">
                            <i className="material-icons">close</i>
                        </button>
                    </div>
                )}
            </Modal>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const TehetsegesHallgatok = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <TehetsegesHallgatokContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default TehetsegesHallgatok;
